"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React from "react"
import useHasMounted from "../../../../hooks/useHasMounted"
import calendarFormat from "../../../../lib/formatter/calendarFormat"

// Small client island for the cohort date. The label is timezone-relative, so it
// is computed in the viewer's local timezone after mount (server + first client
// render show nothing) to avoid a hydration mismatch (React #418). Isolating it
// here lets GroupCard itself be a Server Component — the rest of the card (image,
// text, provider, price, button) renders server-side with no hydration.
export default function GroupCardDate({
  cohortNextStartsAt,
}: {
  cohortNextStartsAt?: string | number | Date | null
}) {
  const hasMounted = useHasMounted()
  return (
    <div className="font-bebas text-18px">
      {hasMounted && cohortNextStartsAt ? calendarFormat(cohortNextStartsAt) : null}
    </div>
  )
}
